module.exports = __webpack_public_path__ + "img/emotion-germany@2x.ba75515.webp";